import * as React from "react";

const Referral = (props) =>
{
    return <div className="referral-wrapper hide">
       <div className="referral">
           <a className="referral-link margin-bottom block" href="#">Been referred by a friend? Click here</a>
       </div>
    </div>
}

export default Referral;